// Modern dinamik menü sistemi
import api from './api';

// Statik fallback menü (API başarısız olursa)
const fallbackMenuData = [
  {
    title: 'Bebek',
    slug: 'bebek',
    subCategories: [
      {
        title: 'Bebek Giyim',
        links: [
          { name: 'Bebek Body', path: '/categories/bebek-body' },
          { name: 'Bebek Tulum', path: '/categories/bebek-tulum' },
          { name: 'Bebek Takım', path: '/categories/bebek-takim' },
        ],
      },
    ],
  },
  {
    title: 'Kız Çocuk',
    slug: 'kiz-cocuk',
    subCategories: [
      {
        title: 'Kız Çocuk Giyim',
        links: [
          { name: 'Kız Elbise', path: '/categories/kiz-elbise' },
          { name: 'Kız T-shirt', path: '/categories/kiz-tshirt' },
        ],
      },
    ],
  },
  {
    title: 'Erkek Çocuk',
    slug: 'erkek-cocuk',
    subCategories: [
      {
        title: 'Erkek Çocuk Giyim',
        links: [
          { name: 'Erkek T-shirt', path: '/categories/erkek-tshirt' },
          { name: 'Erkek Gömlek', path: '/categories/erkek-gomlek' },
        ],
      },
    ],
  },
];

// Cache için
let cachedMenuData = null;
let lastFetchTime = 0;
const CACHE_DURATION = 5 * 60 * 1000; // 5 dakika

// API'den dinamik menü verisi al
export const getMenuData = async () => {
  // Cache kontrolü
  if (cachedMenuData && (Date.now() - lastFetchTime) < CACHE_DURATION) {
    return cachedMenuData;
  }

  try {
    const response = await api.get('/api/categories');
    const categories = response.data || [];
    
    if (!Array.isArray(categories) || categories.length === 0) {
      return fallbackMenuData;
    }

    // API verisini menü formatına dönüştür
    const menuData = categories.map(category => ({
      title: category.name,
      slug: category.slug,
      path: `/categories/${category.slug}`,
      subCategories: category.children ? [
        {
          title: category.name,
          links: [
            { name: `Tüm ${category.name}`, path: `/categories/${category.slug}` },
            ...category.children.map(child => ({
              name: child.name,
              path: `/categories/${child.slug}`
            }))
          ]
        }
      ] : []
    }));

    // Cache'e kaydet
    cachedMenuData = menuData;
    lastFetchTime = Date.now();
    
    return menuData;
  } catch (error) {
    console.error('Menü verileri alınırken hata:', error);
    return fallbackMenuData;
  }
};

// Statik export (geriye uyumluluk için)
export const menuData = fallbackMenuData;